import React, { useState, useEffect, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Form, Input, notification, Row, Col, Button, Breadcrumb, Typography, Spin } from 'antd';
import { backButton, formItemLayout, handleBackendFormErrors, tailFormItemLayout, unexpectedError } from '../../common_functions';

const Signature = props => {
  const { section, id } = useParams();
  const [signature, setSignature] = useState({});
  const [loading, setLoading] = useState(false);
  const formRef = useRef(null);

  useEffect(() => {
    async function fetchData() {
      try {
        setLoading(true);
        if (id !== 'new') {
          const { data } = await props.getItem('signatures', id);
          setSignature(data);
          formRef.current.setFieldsValue(data);
        }
      } catch (error) {
        unexpectedError(error);
      } finally {
        setLoading(false);
      }
    }
    fetchData();
  }, [section, id]);

  let onFinish = async values => {
    let newState = { ...signature, ...values };
    try {
      setLoading(true);
      const response = await props.saveItem('signatures', newState);
      if (response) {
        notification['success']({
          message: 'Signature saved successfully!',
          description: '',
        });
        backButton(props, `/settings/signatures`);
      }
    } catch (errorResponse) {
      handleBackendFormErrors(formRef, errorResponse);
    } finally {
      setLoading(false);
    }
  };

  let onFinishFailed = ({ errorFields }) => {
    formRef.current.scrollToField(errorFields[0].name);
  };

  return (
    <Spin spinning={loading} size="large">
      <Row>
        <Col className="app-breadcrumb-col">
          <Breadcrumb separator="/" items={[{ title: "Settings", href: "/settings/signatures" }, { title: "Signatures", href: "/settings/signatures" }, { title: id !== 'new' ? `Edit Signature` : 'Add Signature' }]} />
        </Col>
        <Col className="white-paper">
          <Row gutter={24} className="page-header-section" align="middle">
            <Col xs={12}>
              <Typography.Title level={4} style={{ margin: 0 }}>
                {id !== 'new' ? `Edit Signature: ${id}` : 'Add Signature'}
              </Typography.Title>
            </Col>
            <Col xs={12} justify="end"></Col>
          </Row>
          <hr />
          <div className="artist">
            <Form
              ref={formRef}
              layout="vertical"
              {...formItemLayout}
              onFinish={onFinish}
              onFinishFailed={onFinishFailed}
              initialValues={{ layout: tailFormItemLayout }}
            >
              {id !== 'new' ? (
                <Row gutter={24}>
                  {' '}
                  <Col xs={24} sm={12} md={12} lg={12}>
                    <Form.Item name="id" label="ID(System Generated)">
                      <Input disabled />
                    </Form.Item>
                  </Col>
                </Row>
              ) : (
                ''
              )}

              <Row gutter={24}>
                <Col xs={24} sm={12} md={12} lg={12}>
                  <Form.Item
                    name="signature"
                    label="Signature"
                    rules={[
                      {
                        whitespace: true,
                        required: true,
                        message: 'Signature is required!',
                      },
                    ]}
                  >
                    <Input placeholder="Enter Signature" />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={24}>
                <Col xs={24} sm={24} md={24} lg={24}>
                  <Form.Item name="description" label="Description">
                    <Input.TextArea rows={5} placeholder="Enter description..." />
                  </Form.Item>
                </Col>
              </Row>
              <Form.Item {...tailFormItemLayout}>
                <Button
                  type="default"
                  htmlType="button"
                  onClick={() => backButton(props, '/settings/signatures')}
                  style={{
                    borderColor: '#d9d9d9',
                    background: '#f5f5f5',
                    color: 'rgba(0, 0, 0, 0.85)',
                  }}
                >
                  Back
                </Button>
                {props.showButton(props.roleType, props.tabs_permissions.settings_signatures, !!signature ? signature.id : '')}
              </Form.Item>
            </Form>
          </div>
        </Col>
      </Row>
    </Spin>
  );
};

export default Signature;
